import Vue from 'vue'
import store from '../store';
import router from '../router';
import httpApi from '@/utils/http';
/**
 * 登录校验 tickeCallback
 * @param  callback
 */
const whiteList = ['/', 'register', 'registerResult']
let enterpriseList;
const loginAuth = callback => {
  // 进行访问页面判断
  console.log("这是回调地址："+window.location.pathname)
  const path = window.location.pathname.substr(0, 14)
  console.log("这是截取后的回调地址："+path)
  switch (path) {
    case '/tickeCallback':
      if (!!getUrlParam('ticket')) {
        /* 一次性token消费处理 */
        let ticket = getUrlParam('ticket')
        let targetUrl = getUrlParam('targetUrl')
        let code = getUrlParam('code').substr(0, 5)
        if (code == 90000) {
          let params = {
            ticket: ticket,
            code: code,
            targetUrl: targetUrl,
          };
          httpApi.post('/dev-api/lhsso/getLoginParams', params).then((multiRole) => {
              if (!multiRole||!multiRole.topbrasses||!multiRole.topbrasses.length) {
                window.location.href = '/'
                alert('登录失败，请联系管理员！')
                return
              }
              enterpriseList = multiRole.topbrasses
              if (enterpriseList.length === 1) {
                login(enterpriseList[0],targetUrl)
              }else{
                //alert("查出多个数据"+JSON.stringify(multiRole))
              }
            })
        } else {
          window.location.href = '/'
        }
      }
      callback()
      break
  }
  callback()
}
/**
 * @description 登录
 * @param {Object} role 角色信息
 */
function  login(role,targetUrl) {
  let params = {
    phone: role.phone,
    userId: role.userId,
  }
  httpApi.post('/dev-api/sms/login', params).then(res => {
    if (res.code == 200) {
      if (res.userInfo) {
        let temp_userInfo = JSON.parse(JSON.stringify(res.userInfo.sysUser))
        temp_userInfo.enterpriseList = enterpriseList
        temp_userInfo.enterpriseInfo = JSON.parse(JSON.stringify(role))
        temp_userInfo.tyshxydm = role.tyshxydm
        temp_userInfo.enterpriseInfo.logoId = res.userInfo.user?.logo
        sessionStorage.setItem('titleType',1)
        store.commit('updateToken', res.token)
        store.commit("updateUserInfo", temp_userInfo)
        sessionStorage.setItem('isFirst',"true");
        if(targetUrl.indexOf('policyMatchReport')>-1){
          sessionStorage.setItem("titleType", 3);
          window.location.href='/policyMatchReport'
        }else{
          sessionStorage.setItem("titleType", 1);
          window.location.href='/'
        }

      }
    }
  }).catch(err => {
    console.log('login error:', err)
  })
}


function getUrlParam(paraName) {
  let url = document.location.toString()
  let arrObj = url.split('?')
  let arrPara = arrObj[1].split('&')
  let arr
  for (let i = 0; i < arrPara.length; i++) {
    arr = arrPara[i].split('=')
    if (arr != null && arr[0] == paraName) {
      return arr[1]
    }
  }
  return ''
}

const SSO = {
  loginAuth: loginAuth
}

export default SSO
